export default __webpack_public_path__ + "static/media/NVL.50f48c57.svg";